// extracted by mini-css-extract-plugin
export var text = "_32-0";